<template>
  <v-app-bar height="48">
    <template v-slot:prepend>
      <div class="hamburger-menu" @click="toggleSideBar()">
        <v-icon icon="mdi-menu" size="large" />
      </div>
      <router-link :to="{ path: '/' }">
        <img src="/img/icons/octlink-icon.png" class="logo" />
      </router-link>
    </template>
    <template v-slot:append>
      <div class="user-info">
        <div>{{ operationOfficeName }}</div>
        <div>{{ email }}</div>
      </div>
      <HelpButton
        :pageName="route.name"
        class="ml-5"
      />
      <div
        v-if="!props.hideNoticeIcon"
        class="ml-5 d-flex flex-column justify-content-center"
      >
        <NoticeMenu :isHamburgerOpen="props.isHamburgerOpen" />
      </div>
      <div class="ms-5 d-flex flex-column justify-content-center">
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-icon
              size="large"
              icon="mdi-account-circle-outline"
              v-bind="props"
            />
          </template>
          <v-list>
            <v-list-item v-if="showSelectRole" @click="redirectSelectRole()">
              {{ i18n.global.t('pages.mainTemplate.selectRole') }}
            </v-list-item>
            <v-list-item @click="logoutAndRedirect()">
              {{ i18n.global.t('pages.mainTemplate.logoutBtn') }}
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
  </v-app-bar>
  <GDialog
    v-model="reloadDialogState"
    persistent="true"
    max-width="30%"
    transition="custom-from-bottom-transition"
  >
    <div class="modal-header justify-content-center pt-3">
      <label>{{ i18n.global.t('pages.mainTemplate.reloadDialog.title') }}</label>
    </div>
    <div class="row mt-2 mr-3 ml-3 pl-5 v-theme--light">
      {{ i18n.global.t('pages.mainTemplate.reloadDialog.message') }}
    </div>
    <div class="d-flex justify-content-end m-3">
      <v-btn class="m-1 reset-btn" @click="closeReloadDialog">
        {{ i18n.global.t('pages.mainTemplate.reloadDialog.closeButton') }}
      </v-btn>
    </div>
  </GDialog>
</template>
<script setup lang="ts">
import NoticeMenu from '@/layout/components/topNavbar/NoticeMenu.vue';
import HelpButton from '@/components/HelpButton.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import Api from '@/services/api/ApiServiceFabrick';
import { onMounted, ref, defineProps, defineEmits, computed } from 'vue';
import i18n from '@/lang/i18n';
import SelectRoleChecker from '@/router/selectRoleChecker';
import { GDialog } from 'gitart-vue-dialog';

const { logout } = useAuth();
const { push } = useRouter();
const route = useRoute();
const operationOfficeName = ref('');
const email = ref('');
const showSelectRole = ref(false)
const reloadDialogState = ref(false);
const currentRoleId = ref(0);

const props = defineProps<{
  isHamburgerOpen?: boolean,
  hideNoticeIcon?: boolean
}>();
const emit = defineEmits<{ (e: 'update:isHamburgerOpen', value: boolean): void }>();

const toggleSideBar = () => {
  emit('update:isHamburgerOpen', !props.isHamburgerOpen);
};


const redirectSelectRole = () => {
  push({ path: '/select_role'});
};

const logoutAndRedirect = () => {
  logout();
  push({ path: '/' });
};

const getSelfInfo = async () => {
  const [account, office] = await Promise.all([
    Api().getSelfAccount(),
    Api().getSelfOffice(),
    SelectRoleChecker.getSelfRoles(),
  ]);
  operationOfficeName.value = role.value?.organization_name ??
    office.operation_office_name ?? office.company_name;
  email.value = account.email ?? '';
  currentRoleId.value = role.value?.id ?? 0;

  const count = await SelectRoleChecker.getRoleCount();
  showSelectRole.value = count != 1;
};

const role = computed(() => {
  const role = localStorage.getItem(SelectRoleChecker.SELECTED_ROLE_KEY)
  if (role) return JSON.parse(role)
  return null;

})

const closeReloadDialog = () => {
  reloadDialogState.value = false;
  location.reload();
};

window.addEventListener('storage', (event) => {
  if (event.key !== SelectRoleChecker.SELECTED_ROLE_KEY) {
    return;
  }

  reloadDialogState.value = !event.newValue || currentRoleId.value !== JSON.parse(event.newValue).id
});

onMounted(() => {
  getSelfInfo();
});
</script>
<style scoped>
.hamburger-menu {
  margin: 0 0.7rem;
  cursor: pointer;
}

@media (min-width: 840px) {
  .hamburger-menu {
    display: none;
  }
}
.logo {
  height: 2rem;
  width: 2rem;
  margin-left: 2px;
}

.user-info {
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
}

</style>
